"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetName = void 0;
var React = require("react");
var ApWidgetBadge_1 = require("../ApWidgetBadge");
var styles_1 = require("./styles");
exports.ApWidgetName = function (_a) {
    var className = _a.className, name = _a.name, iconType = _a.iconType, props = __rest(_a, ["className", "name", "iconType"]);
    return (React.createElement(styles_1.Wrapper, __assign({}, props, { className: "ap-widget-name" + (className ? " " + className : ''), iconType: iconType }),
        iconType && React.createElement(ApWidgetBadge_1.ApWidgetBadge, { type: iconType }),
        React.createElement(styles_1.StyledWidgetName, null, name)));
};
//# sourceMappingURL=ApWidgetName.js.map